import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NEW_REPORT, PERSONA } from 'constants/constant';
import { UserPortalContext } from 'context/appcontext';
import { withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { Button } from '@material-ui/core';
import Persona from '../Dashboard/persona/Persona.component';
import AddIcon from '@material-ui/icons/Add';
const { PURPLE, DARK_PURPLE, WHITE } = colors;
const StyledButton = withStyles({
	root: {
		background: `${PURPLE}`,
		borderRadius: '20px',
		height: 40,
		color: `${WHITE}`,
		width: 150,
		fontSize: '14px',
		fontFamily: 'Bogle-Medium',
		textTransform: 'none',
		'&:hover': {
			background: `${DARK_PURPLE}`
		}
	}
})(Button);

function NewReportButton() {
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { userPersona } = userDetails?.result;
	const { CATMAN, BASIC_CATMAN } = PERSONA;
	const [openPersonaSelection, setOpenPersonaSelection] = useState(null);
	const navigate = useNavigate();

	const handleNewReportClick = (e) => {
		if ([CATMAN, BASIC_CATMAN].includes(userPersona)) {
			setOpenPersonaSelection(e.currentTarget);
			return;
		}
		navigate({
			pathname: '/rbtemplates',
			search: '?notReset=true'
		});
	};
	return (
		<>
			<StyledButton
				id="btn-new-report"
				onClick={(e) => {
					handleNewReportClick(e);
				}}>
				<AddIcon fontSize="small" />
				<span style={{ marginLeft: '8px' }}>{NEW_REPORT}</span>
			</StyledButton>
			<Persona
				openPersonaSelection={openPersonaSelection}
				setOpenPersonaSelection={setOpenPersonaSelection}
			/>
		</>
	);
}

export default NewReportButton;
